// First-visit tips per screen; targets are data-testid values, missing ones are skipped
export const TIPS = {
  "/": [
    { t: "dashboard-month-select", h: "Pick a month", p: "Switch months here. You can also filter by account or household member." },
    { t: "kpi-income", h: "Your month at a glance", p: "Income, spending, savings and what's left — all from your imported statements." },
    { t: "chart-spending-pie", h: "Where the money went", p: "Spending by category. Change a transaction's category and the chart updates." },
    { t: "dashboard-forecast", h: "Looking ahead", p: "The next 30 days of bills and income, based on the bills you've confirmed." },
  ],
  "/upload": [
    { t: "upload-statement-dropzone", h: "Drop statements here", p: "Add one PDF or a whole year at once. Everything is read on this device." },
    { t: "csv-choose-button", h: "Prefer CSV?", p: "Bank CSV downloads are usually the most accurate way to import." },
  ],
  "/transactions": [
    { t: "transaction-search-input", h: "Find anything", p: "Search by description, amount or note." },
    { t: "transactions-table", h: "Edit and categorize", p: "Click a description to edit, split, add notes or mark it as business. Category changes are remembered for that merchant." },
    { t: "add-transaction-button", h: "Add by hand", p: "Add cash spending or anything not on a statement." },
    { t: "tab-audit-history", h: "Edit history", p: "Every change is logged here, and Undo at the top reverses the last one." },
  ],
  "/budget": [
    { t: "budget-summary", h: "Budget vs actual", p: "Each category's budget, what you've spent and what's left this month." },
    { t: "add-manual-item-button", h: "Add what's missing", p: "Add regular costs paid from accounts you don't import." },
    { t: "tab-budget-planning", h: "Plan ahead", p: "Set category limits and spread out yearly expenses." },
  ],
  "/bills": [
    { t: "tab-bills", h: "Recurring bills", p: "Confirm the bills detected from your statements so reminders and the forecast use them." },
    { t: "add-bill-button", h: "Add a bill", p: "Add any bill the app didn't spot." },
    { t: "tab-forecast", h: "Cash-flow forecast", p: "See your projected balance over the next 30, 60 and 90 days." },
  ],
  "/debt": [
    { t: "add-debt-button", h: "Add your debts", p: "Enter the balance, rate and minimum payment from each loan or card statement." },
    { t: "extra-payment-input", h: "Pay off faster", p: "Try an extra monthly amount to see how much sooner you'd be debt-free." },
  ],
  "/goals": [
    { t: "add-goal-button", h: "Save for something", p: "Create a goal with a target. We suggest an affordable monthly amount." },
  ],
  "/reports": [
    { t: "tab-monthly-report", h: "Monthly report", p: "A complete household report you can print or download." },
    { t: "export-pdf-button", h: "Download", p: "Save as PDF, Excel or CSV." },
    { t: "tab-tax-pack", h: "Tax pack", p: "Business, charity and medical costs, miles and the accountant pack for tax time." },
  ],
  "/receipts": [
    { t: "inbox-snap-button", h: "Snap a receipt", p: "Take a photo; the store, date and total are read on the device." },
    { t: "inbox-tab-inbox", h: "Your inbox", p: "Unattached photos wait here with suggested matches. Exact matches attach in one tap." },
    { t: "inbox-tab-search", h: "Search all receipts", p: "Find any receipt by store, amount, note or date, and save searches you use often." },
  ],
  "/settings": [
    { t: "settings-sync", h: "Sync your devices", p: "Move your data between phone and computers by QR code — never through a server." },
    { t: "settings-backup", h: "Back up", p: "Create an encrypted backup file now and then, and keep it somewhere safe." },
    { t: "auto-lock-settings", h: "Lock it down", p: "Set a passcode, auto-lock and Face ID / Touch ID." },
  ],
};

const SEEN = "hb-tips-seen";
const OFF = "hb-tips-off";
const seenList = () => { try { return JSON.parse(localStorage.getItem(SEEN) || "[]"); } catch { return []; } };
export const tipsDue = (route) => !!TIPS[route] && localStorage.getItem(OFF) !== "1" && !seenList().includes(route);
export const markTipsSeen = (route) => localStorage.setItem(SEEN, JSON.stringify([...new Set([...seenList(), route])]));
export const turnOffTips = () => localStorage.setItem(OFF, "1");
export const resetTips = () => { localStorage.removeItem(SEEN); localStorage.removeItem(OFF); };
